import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useParams } from "react-router-dom";
import { getAllFranchise } from "../apis/franchise";
import { getWorkFranchise } from "../apis/workApis";

const FranchiseDetails = () => {
  const { id } = useParams();
  const [franchise, setFranchise] = useState(null);
  const [assigns, setAssigns] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [loading, setLoading] = useState(true);
  const [work, setWork] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    date: "",
    type: "",
    value: "",
    document: null,
  });

  const getPercentage = () => {
    if (!work || !franchise || !work.team) return 0;

    /* ---------- PAYMENT TEAM ---------- */
    if (work.team.name === "Payment") {
      const total = franchise.totalPayment;
      if (total <= 0) return 100;

      const received =
        work.datas.reduce((acc, cur) => acc + Number(cur.value || 0), 0) +
        franchise.initPayment;

      return Math.min(Math.round((received / total) * 100), 100);
    }

    /* ---------- OTHER TEAMS ---------- */
    const fields = work.team.fields || [];
    if (fields.length === 0) return 0;

    const completedCount = fields.filter((field) =>
      work.datas.some(
        (d) =>
          d.type === field &&
          d.value !== undefined &&
          d.value !== null &&
          d.value !== ""
      )
    ).length;

    return Math.round((completedCount / fields.length) * 100);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAllFranchise();
        const franchiseData = res.data.find((f) => f._id === id);
        setFranchise(franchiseData);
        setAssigns(franchiseData?.assign || []);
        setActiveTab(franchiseData?.assign[0]?.team?._id || null);
        const resWork = await getWorkFranchise(
          id,
          franchiseData?.assign[0]?.team?._id
        );
        setWork(resWork.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    if (!activeTab) return;
    const fetchWork = async () => {
      try {
        const resWork = await getWorkFranchise(id, activeTab);
        setWork(resWork.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchWork();
  }, [activeTab]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting:", formData);
    setFormData({ date: "", type: "", value: "", document: null });
    setShowModal(false);
  };

  if (loading) return <div className="p-10 text-center">Loading...</div>;

  const percentage = getPercentage(work?.status);

  return (
    <div className="p-6 space-y-10">
      {/* ---------- Header ---------- */}
      <h1 className="text-2xl font-bold text-gray-800">{franchise?.name}</h1>

      {/* ---------- Team Tabs ---------- */}
      <div className="flex flex-wrap gap-4">
        {assigns.map((team, idx) => (
          <button
            key={team._id}
            onClick={() => setActiveTab(team.team?._id)}
            className={`px-4 py-2 rounded-full font-medium transition ${
              activeTab === team.team?._id
                ? "bg-red-600 text-white shadow-lg"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            {team.team.name}
          </button>
        ))}
      </div>

      {/* ---------- Main Content ---------- */}
      <div className="flex flex-col lg:flex-row gap-10">
        {/* ----- Left Card ----- */}
        <div className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center w-full lg:w-1/4 h-72">
          <div className="w-32 h-32">
            <CircularProgressbar
              value={percentage}
              text={`${percentage}%`}
              strokeWidth={8}
              styles={buildStyles({
                textColor: "#dc2626",
                pathColor: "#dc2626",
                trailColor: "#e5e7eb",
              })}
            />
          </div>
          <div className="mt-6 space-y-2 text-gray-700 font-medium text-center">
            <div>
              <span className="font-bold">Status: </span>
              {work.status}
            </div>
            <div>
              <span className="font-bold">Last Update: </span>
              {new Date(work.updatedAt).toLocaleDateString("en-GB")}
            </div>
            <div>
              <span className="font-bold">Employee: </span>
              {work.employee?.name || "-"}
            </div>
          </div>
        </div>

        {/* ----- Right Table ----- */}
        <div className="bg-white shadow-lg rounded-lg p-6 flex-1">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-red-600">
              {work?.team?.name} History
            </h2>
            {/* <button
              onClick={() => setShowModal(true)}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
            >
              Add {work?.team?.name}
            </button> */}
          </div>

          {work?.team?.name === "Payment" && (
            <div className="bg-gray-100 rounded-lg p-3 mb-4 flex justify-between font-medium text-gray-700">
              <span>
                Total: {franchise?.totalPayment} <br /> Advance:{" "}
                {franchise?.initPayment}
              </span>
              <span>
                Received:{" "}
                {work.datas.reduce((acc, cur) => acc + Number(cur.value), 0)}
              </span>
              <span>
                Balance:{" "}
                {franchise?.totalPayment -
                  (work.datas.reduce((acc, cur) => acc + Number(cur.value), 0) +
                    franchise?.initPayment)}
              </span>
            </div>
          )}

          <div className="overflow-x-auto">
            <table className="w-full text-center border border-gray-200 rounded-lg overflow-hidden">
              <thead className="bg-red-600 text-white">
                <tr>
                  <th className="p-2">S.No</th>
                  <th className="p-2">Date</th>
                  <th className="p-2">Type</th>
                  <th className="p-2">Value</th>
                  <th className="p-2">Document</th>
                </tr>
              </thead>
              <tbody>
                {work.datas.length > 0 ? (
                  work.datas.map((item, index) => (
                    <tr key={index} className="border-t">
                      <td className="p-2">{index + 1}</td>
                      <td className="p-2">
                        {new Date(item.date).toLocaleDateString("en-GB")}
                      </td>
                      <td className="p-2">{item.type}</td>
                      <td className="p-2">{item.value}</td>
                      <td className="p-2">
                        {item.document ? (
                          <a
                            href={item.document}
                            target="_blank"
                            className="text-blue-600 underline"
                          >
                            View
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="p-4 text-gray-500">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ---------- Modal ---------- */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6">
            <h3 className="text-xl font-bold text-red-600 mb-4">
              Add {work?.team?.name} Entry
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
              <input
                type="text"
                name="type"
                placeholder="Type"
                value={formData.type}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
              <input
                type="number"
                name="value"
                placeholder="Value"
                value={formData.value}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
              <input
                type="file"
                name="document"
                onChange={(e) =>
                  setFormData({ ...formData, document: e.target.files[0] })
                }
                className="w-full border rounded px-3 py-2"
              />
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 rounded border"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-red-600 text-white rounded"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FranchiseDetails;
